<template>
  <div class="app-tab">
    <div class="app-tab__item">
      <router-link to="/home">
        <img v-if="$route.path === '/home'" :src="theme == 'dark'
          ? require('@/assets/tabbar/home.png')
          : require('@/assets/tabbar/home-light.png')
          " />
        <img v-else src="~@/assets/tabbar/homebg.png" />
        <span :class="{ theme: $route.path === '/home' }">{{
          $t("首页")
        }}</span>
      </router-link>
    </div>
    <div class="app-tab__item">
      <router-link to="/conditions">
        <img v-if="$route.path === '/conditions'" :src="theme == 'dark'
          ? require('@/assets/tabbar/conditions.png')
          : require('@/assets/tabbar/conditions-light.png')
          " />
        <img v-else src="~@/assets/tabbar/conditionsbg.png" />
        <span :class="{ theme: $route.path === '/conditions' }">{{
          $t("行情")
        }}</span>
      </router-link>
    </div>
    <div class="app-tab__item">
      <router-link to="/options">
        <img v-if="$route.path === '/options'" :src="theme == 'dark'
          ? require('@/assets/tabbar/coin.png')
          : require('@/assets/tabbar/coin-light.png')
          " />
        <img v-else src="~@/assets/tabbar/coinbg.png" />
        <span :class="{ theme: $route.path === '/options' }">{{
          $t("交易")
        }}</span>
      </router-link>
    </div>
    <!-- <div class="app-tab__item">
      <router-link to="/product1">
        <img
          v-if="$route.path === '/product1'"
          :src="
            theme == 'dark'
              ? require('@/assets/tabbar/management.png')
              : require('@/assets/tabbar/management-light.png')
          "
        />
        <img v-else src="~@/assets/tabbar/managementbg.png" />
        <span :class="{ theme: $route.path === '/product1' }">{{
          $t("AI Quant")
        }}</span>
      </router-link>
    </div> -->
    <div class="app-tab__item">
      <router-link to="/asset">
        <img v-if="$route.path === '/asset'" :src="theme == 'dark'
          ? require('@/assets/tabbar/wallet.png')
          : require('@/assets/tabbar/wallet-light.png')
          " />
        <img v-else src="~@/assets/tabbar/walletbg.png" />
        <span :class="{ theme: $route.path === '/asset' }">{{
          $t("资产")
        }}</span>
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: "AppTab",
  data() {
    return {
      //主题颜色
      theme: null,
    };
  },
  created() {
    this.theme = localStorage.getItem("theme");
    console.log(this.theme);
    window.addEventListener("setItemEvent", this.handleStorageChange);
  },
  beforeDestroy() {
    window.removeEventListener("setItemEvent", this.handleStorageChange);
  },
  methods: {
    handleStorageChange(event) {
      console.log(event);
      if (event.key === "theme") {
        this.theme = event.newValue;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/styles/variables.scss";

.app-tab {
  width: 100%;
  max-width: 750px;
  /*height: 0.98rem;*/
  background: var(--bgColor);
  padding-top: 0.1rem;
  border-top: 0.01rem solid var(--divbgColor);
  position: fixed;
  left: 50%;
  bottom: 0;
  z-index: 100;
  transform: translate(-50%, 0);
  display: flex;
  justify-content: space-between;
  align-items: center;

  &__item {
    width: 25%;
    margin-top: 0.04rem;
    display: flex;
    justify-content: center;

    a {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      color: $info;
      text-decoration: none;

      img {
        width: 0.4rem;
        height: 0.4rem;
      }

      span {
        /*margin-top: 0.1rem;*/
        font-size: 0.2rem;
        line-height: 0.4rem;
        color: var(--divtextColor);
      }
    }
  }
}

.theme {
  color: var(--textColor) !important;
}
</style>



// WEBPACK FOOTER //
// src/components/AppTmpl/AppTab.vue